require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[32],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = scrollableDnD;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var SCROLL_DRAG_DISTANCE = 50;
var RESTET_HOVER_BUFFER = 75;
var SCROLL_BUFFER = 15;

function scrollableDnD(Comp) {
  var ScrollableDnD = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2["default"])(ScrollableDnD, _Component);

    function ScrollableDnD() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_distanceX", 0);
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_distanceY", 0);
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseMove", function () {
        if (_this._getPosition() && !_this._raf) {
          _this._raf = requestAnimationFrame(_this._handleMouseOver);
          _this._lastRAFTime = null;
        }
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseOver", function (time) {
        var position = _this._getPosition();

        var boundingRect = _this._node.getBoundingClientRect();

        var rect = {
          top: boundingRect.top - SCROLL_BUFFER,
          bottom: boundingRect.bottom + SCROLL_BUFFER,
          left: boundingRect.left - SCROLL_BUFFER,
          right: boundingRect.right + SCROLL_BUFFER
        };

        if (!_this._lastRAFTime) {
          _this._lastRAFTime = time;
          requestAnimationFrame(_this._handleMouseOver);
        } else if (position && _utils.domUtils.offsetWithinBoundingRect(position, rect)) {
          var dt = (time - _this._lastRAFTime) / 100;
          _this._lastRAFTime = time;
          var distanceBottom = rect.bottom - position.y;
          var distanceTop = position.y - rect.top;
          var distanceLeft = position.x - rect.left;
          var distanceRight = rect.right - position.x;
          var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
          var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
          var isScrollingLeft = distanceLeft > 0 && distanceLeft < SCROLL_DRAG_DISTANCE;
          var isScrollingRight = distanceRight > 0 && distanceRight < SCROLL_DRAG_DISTANCE;

          if (isScrollingTop && isScrollingBottom) {
            isScrollingTop = distanceTop > distanceBottom;
            isScrollingBottom = !isScrollingTop;
          }

          if (isScrollingLeft && isScrollingRight) {
            isScrollingLeft = distanceLeft > distanceRight;
            isScrollingRight = !isScrollingLeft;
          }

          var distanceY = 0;

          if (isScrollingBottom) {
            distanceY = Math.max((SCROLL_DRAG_DISTANCE - distanceBottom) * dt, 1);
          } else if (isScrollingTop) {
            distanceY = -Math.max((SCROLL_DRAG_DISTANCE - distanceTop) * dt, 1);
          }

          _this._node.scrollTop += distanceY;

          if (distanceY) {
            _this._distanceY += Math.abs(distanceY);
          } else {
            _this._distanceY = 0;
          }

          var distanceX = 0;

          if (isScrollingLeft) {
            distanceX = -Math.max((SCROLL_DRAG_DISTANCE - distanceLeft) * dt, 1);
          } else if (isScrollingRight) {
            distanceX = Math.max((SCROLL_DRAG_DISTANCE - distanceRight) * dt, 1);
          }

          _this._node.scrollLeft += distanceX;

          if (distanceX) {
            _this._distanceX += Math.abs(distanceX);
          } else {
            _this._distanceX = 0;
          }

          if ((isScrollingTop || isScrollingBottom || isScrollingLeft || isScrollingRight) && (_this._distanceX > RESTET_HOVER_BUFFER || _this._distanceY > RESTET_HOVER_BUFFER)) {
            _this._resetHover();
          }

          requestAnimationFrame(_this._handleMouseOver);
        } else {
          _this._distanceX = 0;
          _this._distanceY = 0;
          cancelAnimationFrame(_this._raf);
          _this._raf = null;
        }
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getPosition", function () {
        return _this.context.dragDropManager.getMonitor().getClientOffset();
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_resetHover", function () {
        return _this.context.dragDropManager.getActions().hover([], {
          clientOffset: _this._getPosition()
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (r) {
        var scrollableDnDForwardRef = _this.props.scrollableDnDForwardRef;
        _this.wrappedComponent = r;
        _this._node = _reactDom["default"].findDOMNode(r);
        scrollableDnDForwardRef && scrollableDnDForwardRef(r);
      });
      return _this;
    }

    var _proto = ScrollableDnD.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this._node.addEventListener('mousemove', this._handleMouseMove);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      cancelAnimationFrame(this._raf);
    };

    _proto.render = function render() {
      var _this$props = this.props,
          scrollableDnDForwardRef = _this$props.scrollableDnDForwardRef,
          others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["scrollableDnDForwardRef"]);
      return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({}, others, {
        ref: this._ref
      }));
    };

    return ScrollableDnD;
  }(_react.Component);

  (0, _defineProperty2["default"])(ScrollableDnD, "propTypes", {
    scrollableDnDForwardRef: _propTypes["default"].any
  });
  (0, _defineProperty2["default"])(ScrollableDnD, "contextTypes", {
    dragDropManager: _propTypes["default"].object
  });
  return _react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(ScrollableDnD, (0, _extends2["default"])({}, props, {
      scrollableDnDForwardRef: ref
    }));
  });
}

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(306);


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _itemDnD = _interopRequireWildcard(__webpack_require__(307));

exports["default"] = _itemDnD["default"];
exports.itemDnD = _itemDnD["default"];
exports.ITEM_TYPE = _itemDnD.ITEM_TYPE;

var _scrollableDnD = _interopRequireDefault(__webpack_require__(100));

exports.scrollableDnD = _scrollableDnD["default"];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = _default;
exports.ITEM_TYPE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _reactDnd = __webpack_require__(26);

var _utils = __webpack_require__(4);

var _scrollableDnD = _interopRequireDefault(__webpack_require__(100));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var omit = _utils.lodash.omit;
var lastHoveredYPercent;
var lastHoveredXPercent;

var idFn = function idFn(x) {
  return x;
};

var ITEM_TYPE = 'ITEM_TYPE';
exports.ITEM_TYPE = ITEM_TYPE;

function _default(Comp, _ref) {
  var dragItemType = _ref.dragItemType,
      dropItemType = _ref.dropItemType,
      _ref$simpleHoverState = _ref.simpleHoverStates,
      simpleHoverStates = _ref$simpleHoverState === void 0 ? true : _ref$simpleHoverState,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable;

  var getHoveredY = function getHoveredY() {
    if (simpleHoverStates) {
      return lastHoveredYPercent >= 50;
    }

    return lastHoveredYPercent;
  };

  var getHoveredX = function getHoveredX() {
    if (simpleHoverStates) {
      return lastHoveredXPercent >= 50;
    }

    return lastHoveredXPercent;
  };

  var dropTargetMethods = {
    canDrop: function canDrop(props, monitor) {
      if (props.canDrop) {
        return props.canDrop((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }

      return false;
    },
    drop: function drop(props, monitor, component) {
      // eslint-disable-line no-unused-vars
      if (props.onDrop && !monitor.didDrop()) {
        props.onDrop((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }
    },
    hover: function hover(props, monitor, component) {
      var hoverBoundingRect = (props.customDnDNode || _reactDom["default"].findDOMNode(component)).getBoundingClientRect();

      var clientOffset = monitor.getClientOffset();
      var hoverClientY = clientOffset.y - hoverBoundingRect.top;
      var hoverClientX = clientOffset.x - hoverBoundingRect.left;
      lastHoveredYPercent = hoverClientY / (hoverBoundingRect.bottom - hoverBoundingRect.top) * 100;
      lastHoveredXPercent = hoverClientX / (hoverBoundingRect.right - hoverBoundingRect.left) * 100;

      if (props.onHover) {
        props.onHover((props.getDropProps || idFn)(props, getHoveredY(), getHoveredX()), monitor.getItem(), monitor);
      }

      if (simpleHoverStates) {
        // forceUpdate in order to pass down updated hover states to child component
        component.forceUpdate();
      }
    }
  };
  var dragSourceMethods = {
    beginDrag: function beginDrag(props) {
      var onBeginDrag = props.onBeginDrag;
      return (onBeginDrag || idFn)(props);
    },
    canDrag: function canDrag(props) {
      var canDragNode = props.canDragNode;
      return !canDragNode || canDragNode(props);
    },
    endDrag: function endDrag(props) {
      props.onEndDrag && props.onEndDrag(props);
    }
  };

  var addDropTarget = function addDropTarget() {
    return (0, _reactDnd.DropTarget)(dropItemType, dropTargetMethods, function (connect, monitor) {
      return {
        connectDropTarget: connect.dropTarget(),
        isActive: function isActive() {
          return monitor.isOver() && monitor.canDrop();
        }
      };
    });
  };

  var addDragSource = function addDragSource() {
    return (0, _reactDnd.DragSource)(dragItemType, dragSourceMethods, function (connect) {
      return {
        connectDragSource: connect.dragSource()
      };
    });
  };

  var WrappedComponent = Comp;

  if (scrollable) {
    WrappedComponent = (0, _scrollableDnD["default"])(Comp);
  }

  var Item = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2["default"])(Item, _Component);

    function Item() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_resovleRef", function (ref) {
        var node = _reactDom["default"].findDOMNode(ref);

        if (node && !_this.props.customDnDNode) {
          _this._connectToDnD(node);
        }

        var itemDnDForwardRef = _this.props.itemDnDForwardRef;
        itemDnDForwardRef && itemDnDForwardRef(ref);
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_connectToDnD", function (node) {
        var _this$props = _this.props,
            connectDragSource = _this$props.connectDragSource,
            connectDropTarget = _this$props.connectDropTarget;
        connectDropTarget && connectDropTarget(node);
        connectDragSource && connectDragSource(node);
      });
      return _this;
    }

    var _proto = Item.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var customDnDNode = this.props.customDnDNode;

      if (customDnDNode) {
        this._connectToDnD(customDnDNode);
      }
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.customDnDNode && nextProps.customDnDNode !== this.props.customDnDNode) {
        this._connectToDnD(nextProps.customDnDNode);
      }
    };

    _proto.render = function render() {
      var _this$props2 = this.props,
          isActive = _this$props2.isActive,
          dragLayerRenderer = _this$props2.dragLayerRenderer,
          other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["isActive", "dragLayerRenderer"]);
      var passThroughProps = (0, _extends2["default"])({}, omit(other, 'canDrop', 'canDragNode', 'onBeginDrag', 'onEndDrag', 'connectDropTarget', 'connectDragSource', 'getDropProps', 'onHover', 'customDnDNode', 'itemDnDForwardRef'));
      var active = isActive && isActive();
      var hoverProps = {
        hoveredActive: active
      };

      if (active && simpleHoverStates) {
        var hoveredBelow = getHoveredY();
        var hoveredRight = getHoveredX();
        hoverProps = (0, _extends2["default"])({}, hoverProps, {
          hoveredRight: hoveredRight,
          hoveredBelow: hoveredBelow,
          hoveredAbove: !hoveredBelow,
          hoveredLeft: !hoveredRight
        });
      }

      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, hoverProps, passThroughProps, {
        ref: this._resovleRef
      }));
    };

    return Item;
  }(_react.Component);

  (0, _defineProperty2["default"])(Item, "propTypes", {
    customDnDNode: _propTypes["default"].object,
    dragging: _propTypes["default"].bool,
    itemRenderer: _propTypes["default"].func,
    // NOTE: isRequired causing warning 'undefined' in console. Removed isRequired for now - can be added back if any side effects or new insights.
    connectDropTarget: _propTypes["default"].func.isRequired,
    connectDragSource: _propTypes["default"].func.isRequired,
    dragLayerRenderer: _propTypes["default"].func,
    // NOTE: isRequired causing warning 'undefined' in console. Removed isRequired for now - can be added back if any side effects or new insights.
    isActive: _propTypes["default"].func.isRequired,
    getDropProps: _propTypes["default"].func.isRequired,
    onBeginDrag: _propTypes["default"].func.isRequired,
    itemDnDForwardRef: _propTypes["default"].any
  });
  var ItemDnD = Item;

  if (dragItemType) {
    ItemDnD = addDragSource()(ItemDnD);
  }

  if (dropItemType) {
    ItemDnD = addDropTarget()(ItemDnD);
  }

  if (ItemDnD === Item) {
    throw new Error("itemDnD: 'dragItemType' and/or 'dropItemType' must be provided");
  }

  return _react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(ItemDnD, (0, _extends2["default"])({}, props, {
      itemDnDForwardRef: ref
    }));
  });
}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[305,0]]]);
});